'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrugBadgeData$$anon$1(f$2, outer) {
  this.Lapp_data_DrugBadgeData$$anon$1__f_f$1 = null;
  this.Lapp_data_DrugBadgeData$$anon$1__f_$outer = null;
  this.Lapp_data_DrugBadgeData$$anon$1__f_f$1 = f$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lapp_data_DrugBadgeData$$anon$1__f_$outer = outer;
}
export { $c_Lapp_data_DrugBadgeData$$anon$1 as $c_Lapp_data_DrugBadgeData$$anon$1 };
$c_Lapp_data_DrugBadgeData$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_DrugBadgeData$$anon$1.prototype.constructor = $c_Lapp_data_DrugBadgeData$$anon$1;
/** @constructor */
function $h_Lapp_data_DrugBadgeData$$anon$1() {
}
export { $h_Lapp_data_DrugBadgeData$$anon$1 as $h_Lapp_data_DrugBadgeData$$anon$1 };
$h_Lapp_data_DrugBadgeData$$anon$1.prototype = $c_Lapp_data_DrugBadgeData$$anon$1.prototype;
$c_Lapp_data_DrugBadgeData$$anon$1.prototype.formulation__O__T = (function(a) {
  return this.Lapp_data_DrugBadgeData$$anon$1__f_$outer.formulation__O__T(this.Lapp_data_DrugBadgeData$$anon$1__f_f$1.apply__O__O(a));
});
$c_Lapp_data_DrugBadgeData$$anon$1.prototype.strength__O__T = (function(a) {
  return this.Lapp_data_DrugBadgeData$$anon$1__f_$outer.strength__O__T(this.Lapp_data_DrugBadgeData$$anon$1__f_f$1.apply__O__O(a));
});
$c_Lapp_data_DrugBadgeData$$anon$1.prototype.quantity__O__T = (function(a) {
  return this.Lapp_data_DrugBadgeData$$anon$1__f_$outer.quantity__O__T(this.Lapp_data_DrugBadgeData$$anon$1__f_f$1.apply__O__O(a));
});
var $d_Lapp_data_DrugBadgeData$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrugBadgeData$$anon$1, "app.data.DrugBadgeData$$anon$1", ({
  Lapp_data_DrugBadgeData$$anon$1: 1,
  Lapp_data_DrugBadgeData: 1
}));
export { $d_Lapp_data_DrugBadgeData$$anon$1 as $d_Lapp_data_DrugBadgeData$$anon$1 };
//# sourceMappingURL=app.data.-Drug-Badge-Data$$anon$1.js.map
